export default __webpack_public_path__ + "static/media/snow-C1.0774be53.png";